export const DICTIONARY_QUERY_PARAMS = ['hardware_q', 'platform_q', 'tag_q'];

export function syncReturnQueries(form, windowRef) {
    if (!(form instanceof HTMLFormElement) || typeof windowRef?.location?.href !== 'string') {
        return;
    }

    const url = new URL(windowRef.location.href);
    DICTIONARY_QUERY_PARAMS.forEach((queryParam) => {
        let input = form.querySelector(`[data-dictionary-return-query="${queryParam}"]`);
        const value = url.searchParams.get(queryParam) ?? '';

        if (!(input instanceof HTMLInputElement)) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = queryParam;
            input.dataset.dictionaryReturnQuery = queryParam;
            form.append(input);
        }

        input.value = value;
        input.disabled = value === '';
    });
}
